import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ResetIcon = ({
  color = 'black50',
  width = 22,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 4.40002C9.22918 4.40003 6.57141 7.43377 6.57141 11.4H4.57141C4.57141 6.52973 7.93422 2.40002 13 2.40002C17.9705 2.40002 22 6.42946 22 11.4C22 16.3706 17.9705 20.4 13 20.4V18.4C16.866 18.4 20 15.266 20 11.4C20 7.53403 16.866 4.40002 13 4.40002ZM4.57141 12.4145V11.4002H6.57141V12.4145L9.4357 9.55017L10.8499 10.9644L5.57138 16.2429L0.292847 10.9644L1.70706 9.55017L4.57141 12.4145Z"
          fill={getSemanticTextColor(color)}
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
